import spinnerIMG from '@/assets/imgs/misc/spinner.png';
import { Image } from '@/components/generic';
import { cn } from '@/lib/utils';

type SpinnerProps = {
  className?: string;
};

export const Spinner = ({ className }: SpinnerProps) => (
  <div
    className={cn(
      `flex justify-center items-center w-12 h-12 mx-auto bg-b-surface2 rounded-full overflow-hidden`,
      className || '',
    )}
  >
    <Image
      className='size-6 opacity-100 animate-spin-reverse'
      src={spinnerIMG}
      alt='spinner'
    />
  </div>
);
